import React from 'react'

import style from './PageTitle.module.scss'

export const PageTitle = ({ title }) => (
  <h2 data-testid='page-title' className={style.title}>
    {title}
  </h2>
)
